import React from 'react'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

interface Props {
  score100: number
}

interface State { }

export class ScoreGauge extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  get fgColor() {
    if (this.props.score100 < 50) {
      return '#ff283a'
    } else if (this.props.score100 < 90) {
      return '#ffa400'
    } else {
      return '#0cce6b'
    }
  }

  get bgColor() {
    if (this.props.score100 < 50) {
      return '#ffeced'
    } else if (this.props.score100 < 90) {
      return '#fff7eb'
    } else {
      return '#e2fbf0'
    }
  }

  public render() {
    return (
      <div className="gauge">
        <CircularProgressbar
          value={this.props.score100}
          text={this.props.score100.toString()}
          strokeWidth={8}
          background={true}
          styles={
            buildStyles({
              textSize: '200%',
              pathColor: this.fgColor,
              textColor: this.fgColor,
              backgroundColor: this.bgColor,
              trailColor: this.bgColor,
            })
          }
        ></CircularProgressbar>
      </div>
    )
  }
}